import { PLATFORM_URL, PAGE_URL } from '../value/Url';

import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { VERSION } from './config';
import { SESSIONSTORAGE } from '../value/staticValues';
import { base64Decoding, base64Encoding, clearSessionStorage } from './util';

const ApiBase: AxiosInstance = axios.create({
    baseURL: PLATFORM_URL.BASE,
    withCredentials: true
});

ApiBase.interceptors.request.use(
    async config => {
        const apiKey = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.API_KEY));
        config.headers = {
            "Content-Type": 'application/json',
            "X-REQUEST-FROM": "FNXCLD-WPT",
            "Authorization": apiKey
        }
        return config
    }
)
ApiBase.interceptors.response.use((response) => {
    return response;
}, async function (error) {
    const originalRequest = error.config;
    if (originalRequest && error.response.status === 401 && error.response.headers.error_code === 'EXP_TOK') {
        originalRequest._retry = true;

        const refreshKey = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.RSH_KEY));
        const apiKey = await refreshToken(refreshKey);
        if (apiKey) {
            originalRequest.headers['Authorization'] = apiKey;
            sessionStorage.setItem(SESSIONSTORAGE.API_KEY, base64Encoding(apiKey));
        }
        return axios(originalRequest);
    }
    return Promise.reject(error);
})

const responseBody = (response: any) => response;
const responseTableBody = (response: any) => response;

const errorBody = (error: any) => {
    if(error.response.status === 401) {
        if (error.response.headers.error_code === 'CHG_DEV') {
            clearSessionStorage();
            window.location.href = `${PAGE_URL.LOGIN}?err_sts=change`;
        }
        else if(error.response.headers.error_code === 'LT_UNUSED') {
            clearSessionStorage();
            window.location.href = `${PAGE_URL.LOGIN}?err_sts=long`;
        } else if(error.response.headers.error_code === 'INV_TOK') {
            clearSessionStorage();
            window.location.href = `${PAGE_URL.LOGIN}`;
        } else {
            throw error.response;
        }
        
    }
    else if (error.response?.status === 500 || error.response?.status === 504) {
        // Portal API 서버 에러
        throw error.response;
    }
    else {
        throw error.response;
    }
}

export const requests = {
    get: (url: string, params ?: {}) => ApiBase.get(url, { params: params})
    .then(responseBody)
    .catch(errorBody),
    getFile: (url: string, params ?: {}) => ApiBase.get(url, { params: params, responseType:'blob'}, )
    .then(responseBody)
    .catch(errorBody),
    tableget: (url: string, params ?: {}) => ApiBase.get(url, { params: params})
    .then(responseTableBody)
    .catch(errorBody),
    post: (url: string, body: {}) => ApiBase.post(url, body)
    .then(responseBody)
    .catch(errorBody),
    put: (url: string, body: {}) => ApiBase.put(url, body)
    .then(responseBody)
    .catch(errorBody),
    delete: (url: string) => ApiBase.delete(url)
    .then(responseBody)
    .catch(errorBody),
};

async function refreshToken(key:string) {
    let apiKey = "";

    await fetch(PLATFORM_URL.BASE + PLATFORM_URL.REFRESH, {
        method: "POST",
        headers: {
            "Content-Type": 'application/json',
            "X-REQUEST-FROM": "FNXCLD-WPT",
            "Authorization": key
        }
    })
    .then((response) => response.json())
    .then((data) => {
        apiKey = data.access_token;
    })
    return apiKey
}
